export default __webpack_public_path__ + "static/media/mangococktail.6c40ab83.jpg";